import * as React from 'react';

import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import { MerchOrderVariant } from '@services/merch/types/api/create-merch-order';

import AppState from '@webapp/store/state';
import { ProductSample } from '@webapp/store/merch/state';
import { getProductSampleVariants } from '@webapp/store/merch/selectors';

import ShippingDetails from './shipping-details';
import ProductColorSize from './product-color-size';
import ReceiveSampleProduct from './receive-sample-product';

import ErrorMessage from '@components/basics/error-message';
import MotionOpacity from '@components/motion/motion-opacity';
import BoxTitleHeader from '@components/layout/box-title-header';
import Box from '@components/layout/box';
import Grid from '@components/basics/grid';

interface MerchProductSampleStateProps {
  className?: string;
  receiveSample?: boolean;
  isLoading?: boolean;
  productSample?: ProductSample | null | undefined;
  standardPrice?: number;
  validationErrorId?: string | null;
  isInvalidProductVariants?: boolean;
}

const mapStateToProps = (state: AppState) => {
  const productSample = state.merch.active?.productSample;
  const receiveSample =
    state.merch.active?.productSample?.receiveSample || false;
  const standardPrice =
    state.merch.active?.productSample?.shippingPrice?.standard || 0;
  const newProduct = state.merch.active?.newProduct;
  const editProduct = state.merch.active?.editProduct;
  const selectedVariants: MerchOrderVariant[] =
    (productSample &&
      getProductSampleVariants({
        productSample,
        editProduct,
        newProduct,
      })) ??
    [];

  const isInvalidProductVariants = !!(
    productSample?.productColors?.length &&
    productSample.productSize &&
    selectedVariants?.length === 0
  );

  return {
    receiveSample,
    productSample,
    standardPrice,
    isInvalidProductVariants,
  };
};

const MerchProductSample: React.FC<MerchProductSampleStateProps> = ({
  className,
  receiveSample,
  productSample,
  standardPrice,
  isLoading,
  validationErrorId,
  isInvalidProductVariants,
}) => {
  const hasShippingDetails =
    !!receiveSample &&
    !!productSample?.productColors?.length &&
    !!productSample?.productSize;

  const hasShippingOptions =
    !!receiveSample &&
    !isLoading &&
    !!productSample?.productColors?.length &&
    !!productSample?.productSize &&
    !!standardPrice;
  return (
    <MotionOpacity className={className}>
      <Grid gap={3}>
        <Box noBorderTop noBorderBottom={receiveSample}>
          <BoxTitleHeader
            className="mb-20"
            title={<Translate id="MERCH.PRODUCT_SAMPLE.TITLE" />}
            text={<Translate id="MERCH.PRODUCT_SAMPLE.TEXT" />}
          />
          <ReceiveSampleProduct />
        </Box>
        {receiveSample && (
          <ProductColorSize hasItemBelow={hasShippingDetails} />
        )}
        {isInvalidProductVariants ? (
          <ErrorMessage
            hasBackground
            className="mt-5 mb-5"
            errorId="MERCH.PRODUCT_SAMPLE.EMPTY_PRODUCT_VARIANTS_ERROR"
          />
        ) : (
          <>
            {hasShippingDetails && (
              <ShippingDetails hasItemBelow={hasShippingOptions} />
            )}
            {validationErrorId && (
              <ErrorMessage
                hasBackground
                className="mt-10"
                errorId={validationErrorId}
              />
            )}
          </>
        )}
      </Grid>
    </MotionOpacity>
  );
};

export default connect(mapStateToProps)(MerchProductSample);
